// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { css } from '@emotion/css';
import { Container, Theme, useTheme } from '@mui/material';

import DefaultErrorFallback from '@components/Fallbacks/DefaultErrorFallback';

import { DealerMovePlannerContent, DealerMovePlannerProvider } from '@features/moveCreation/plannerMount';
import MovePlannerProgramCoverage from '@features/moveCreation/components/MovePlannerProgramCoverage';

// COMPONENT ---------------------------------------------------------------- //

const MovePlannerPage = () => {
  const theme = useTheme();
  const cls = useStyles(theme);

  const location = useLocation();
  const state = location?.state;

  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <DefaultErrorFallback
          message='Unexpected error caught at MovePlannerPage.tsx'
          error={error as Error}
          resetError={resetError}
        />
      )}
    >
      <DealerMovePlannerProvider state={state}>
        <div className={cls.pageContainer}>
          {/* Full-width, pinned under the app header. Outside the maxWidth
              container so it spans the screen when stuck; self-gates to nothing
              until the customer is enrolled and a lane is selected. */}
          <MovePlannerProgramCoverage />
          <Container maxWidth='lg'>
            <DealerMovePlannerContent />
          </Container>
        </div>
      </DealerMovePlannerProvider>
    </Sentry.ErrorBoundary>
  );
};

// STYLES ---------------------------------------------------------------- //

const useStyles = (theme?: Theme) => {
  return {
    page: css`
      position: relative;
    `,
    pageContainer: css`
      padding: ${theme?.spacing(3)} 0;
      min-height: 100vh;
    `,
  };
};

// EXPORT ---------------------------------------------------------------- //

export default MovePlannerPage;
